module.exports = __webpack_public_path__ + "img/document.cf48aaa5.svg";